export interface StudentDocument {
  id: string;
  name: string;
  required: boolean;
  uploaded: boolean;
  fileName?: string;
}

export interface StudentRecord {
  id: string;
  studentId: string;
  name: string;
  dob: string;
  address: string;
  aadhaarNumber: string;
  udidNumber: string;
  className: string;
  classTeacher: string;
  fatherName: string;
  motherName: string;
  contactNumberF: string;
  contactNumberM: string;
  email: string;
  district: string;
  town: string;
  status: 'enrolled' | 'pending' | 'draft' | 'inactive';
  enrolledDate?: string;
  deactivatedAt?: string;
  documents: StudentDocument[];
}

export const classTeacherMap: Record<string, string> = {
  'Pre Primary - A': 'Ms. Emily Watson',
  'Pre Primary - B': 'Ms. Jennifer Lee',
  'Primary - A':     'Dr. Sarah Mitchell',
  'Primary - B':     'Mr. James Okafor',
  'Secondary - A':   'Ms. Emma Reyes',
  'Secondary - B':   'Mr. David Kumar',
};

export const classSections = [
  'Pre Primary - A',
  'Pre Primary - B',
  'Primary - A',
  'Primary - B',
  'Secondary - A',
  'Secondary - B',
];

export const documentTypes: Omit<StudentDocument, 'id'>[] = [
  { name: 'Disability Certificate', required: true, uploaded: false },
  { name: 'Birth Certificate', required: true, uploaded: false },
  { name: 'Ration Card Copy', required: true, uploaded: false },
  { name: 'Income Certificate', required: true, uploaded: false },
  { name: 'UDID Card', required: true, uploaded: false },
  { name: 'Aadhaar Card', required: true, uploaded: false },
  { name: 'Bank Passbook', required: true, uploaded: false },
  { name: 'Medication / Medical Documents', required: false, uploaded: false },
  { name: 'Other Documents', required: false, uploaded: false },
  { name: 'Notes', required: false, uploaded: false },
];

export const students: StudentRecord[] = [
  {
    id: 'stu-001',
    studentId: 'STU-2024-001',
    name: 'Aarav Mehta',
    dob: '2016-03-12',
    address: '42, Laxmi Nagar, Near Govt School, Ward No. 3',
    aadhaarNumber: '3456-7890-1234',
    udidNumber: 'UDID-MH-2023-004567',
    className: 'Pre Primary - A',
    classTeacher: 'Ms. Emily Watson',
    fatherName: 'Rajesh Mehta',
    motherName: 'Sunita Mehta',
    contactNumberF: '+91 98765 43210',
    contactNumberM: '+91 98765 43211',
    email: 'rajesh.mehta@email.com',
    district: 'Nagpur',
    town: 'Nagpur Central',
    status: 'enrolled',
    enrolledDate: '2024-06-15',
    documents: [
      { id: 'doc-001-1', name: 'Disability Certificate', required: true, uploaded: true, fileName: 'aarav_disability_cert.pdf' },
      { id: 'doc-001-2', name: 'Birth Certificate', required: true, uploaded: true, fileName: 'aarav_birth_cert.pdf' },
      { id: 'doc-001-3', name: 'Ration Card Copy', required: true, uploaded: true, fileName: 'aarav_ration_card.pdf' },
      { id: 'doc-001-4', name: 'Income Certificate', required: true, uploaded: true, fileName: 'aarav_income_cert.pdf' },
      { id: 'doc-001-5', name: 'UDID Card', required: true, uploaded: true, fileName: 'aarav_udid_card.pdf' },
      { id: 'doc-001-6', name: 'Aadhaar Card', required: true, uploaded: true, fileName: 'aarav_aadhaar.pdf' },
      { id: 'doc-001-7', name: 'Bank Passbook', required: true, uploaded: true, fileName: 'aarav_passbook.pdf' },
      { id: 'doc-001-8', name: 'Medication / Medical Documents', required: false, uploaded: false },
      { id: 'doc-001-9', name: 'Other Documents', required: false, uploaded: false },
      { id: 'doc-001-10', name: 'Notes', required: false, uploaded: false },
    ],
  },
  {
    id: 'stu-002',
    studentId: 'STU-2024-002',
    name: 'Priya Sharma',
    dob: '2015-08-24',
    address: '18, Ganesh Colony, Behind Post Office',
    aadhaarNumber: '4567-8901-2345',
    udidNumber: 'UDID-MH-2023-005678',
    className: 'Pre Primary - B',
    classTeacher: 'Ms. Jennifer Lee',
    fatherName: 'Amit Sharma',
    motherName: 'Neha Sharma',
    contactNumberF: '+91 87654 32109',
    contactNumberM: '+91 87654 32108',
    email: 'amit.sharma@email.com',
    district: 'Pune',
    town: 'Hadapsar',
    status: 'enrolled',
    enrolledDate: '2024-06-20',
    documents: [],
  },
  {
    id: 'stu-003',
    studentId: 'STU-2024-003',
    name: 'Liam Chen',
    dob: '2014-11-05',
    address: '7B, Rosewood Apartments, MG Road',
    aadhaarNumber: '5678-9012-3456',
    udidNumber: 'UDID-MH-2023-006789',
    className: 'Primary - A',
    classTeacher: 'Dr. Sarah Mitchell',
    fatherName: 'David Chen',
    motherName: 'Mei Ling Chen',
    contactNumberF: '+91 76543 21098',
    contactNumberM: '+91 76543 21097',
    email: 'david.chen@email.com',
    district: 'Mumbai',
    town: 'Andheri East',
    status: 'enrolled',
    enrolledDate: '2024-05-10',
    documents: [
      { id: 'doc-003-1', name: 'Disability Certificate', required: true, uploaded: true, fileName: 'liam_disability_cert.pdf' },
      { id: 'doc-003-2', name: 'Birth Certificate', required: true, uploaded: true, fileName: 'liam_birth_cert.pdf' },
      { id: 'doc-003-3', name: 'Ration Card Copy', required: true, uploaded: true, fileName: 'liam_ration_card.pdf' },
      { id: 'doc-003-4', name: 'Income Certificate', required: true, uploaded: true, fileName: 'liam_income_cert.pdf' },
      { id: 'doc-003-5', name: 'UDID Card', required: true, uploaded: true, fileName: 'liam_udid_card.pdf' },
      { id: 'doc-003-6', name: 'Aadhaar Card', required: true, uploaded: false },
      { id: 'doc-003-7', name: 'Bank Passbook', required: true, uploaded: false },
      { id: 'doc-003-8', name: 'Medication / Medical Documents', required: false, uploaded: true, fileName: 'liam_medication_notes.pdf' },
      { id: 'doc-003-9', name: 'Other Documents', required: false, uploaded: false },
      { id: 'doc-003-10', name: 'Notes', required: false, uploaded: false },
    ],
  },
  {
    id: 'stu-004',
    studentId: 'STU-2024-004',
    name: 'Zara Rodriguez',
    dob: '2013-06-18',
    address: '55, Church Street, Opposite Central Park',
    aadhaarNumber: '6789-0123-4567',
    udidNumber: 'UDID-MH-2023-007890',
    className: 'Primary - B',
    classTeacher: 'Mr. James Okafor',
    fatherName: 'Carlos Rodriguez',
    motherName: 'Maria Rodriguez',
    contactNumberF: '+91 65432 10987',
    contactNumberM: '+91 65432 10986',
    email: 'carlos.rod@email.com',
    district: 'Thane',
    town: 'Kalyan',
    status: 'enrolled',
    enrolledDate: '2024-06-01',
    documents: [],
  },
  {
    id: 'stu-005',
    studentId: 'STU-2024-005',
    name: 'Ethan Williams',
    dob: '2011-09-30',
    address: '23, Hill View Society, Near Sai Temple',
    aadhaarNumber: '7890-1234-5678',
    udidNumber: 'UDID-MH-2023-008901',
    className: 'Secondary - A',
    classTeacher: 'Ms. Emma Reyes',
    fatherName: 'Robert Williams',
    motherName: 'Grace Williams',
    contactNumberF: '+91 54321 09876',
    contactNumberM: '+91 54321 09875',
    email: 'robert.williams@email.com',
    district: 'Nashik',
    town: 'Nashik Road',
    status: 'enrolled',
    enrolledDate: '2024-04-22',
    documents: [],
  },
  {
    id: 'stu-006',
    studentId: 'STU-2024-006',
    name: 'Sofia Nakamura',
    dob: '2017-01-14',
    address: '9, Sakura Lane, Teachers Colony',
    aadhaarNumber: '8901-2345-6789',
    udidNumber: 'UDID-MH-2023-009012',
    className: 'Pre Primary - A',
    classTeacher: 'Ms. Emily Watson',
    fatherName: 'Kenji Nakamura',
    motherName: 'Yuki Nakamura',
    contactNumberF: '+91 43210 98765',
    contactNumberM: '+91 43210 98764',
    email: 'kenji.n@email.com',
    district: 'Nagpur',
    town: 'Dharampeth',
    status: 'enrolled',
    enrolledDate: '2024-07-03',
    documents: [],
  },
  {
    id: 'stu-007',
    studentId: 'STU-2024-007',
    name: 'Rohan Patil',
    dob: '2015-04-28',
    address: '14, Sai Krupa Building, Ring Road',
    aadhaarNumber: '9012-3456-7890',
    udidNumber: 'UDID-MH-2024-010123',
    className: 'Pre Primary - B',
    classTeacher: 'Ms. Jennifer Lee',
    fatherName: 'Suresh Patil',
    motherName: 'Anjali Patil',
    contactNumberF: '+91 32109 87654',
    contactNumberM: '+91 32109 87653',
    email: 'suresh.patil@email.com',
    district: 'Aurangabad',
    town: 'CIDCO',
    status: 'pending',
    documents: [
      { id: 'doc-007-1', name: 'Disability Certificate', required: true, uploaded: true, fileName: 'rohan_disability_cert.pdf' },
      { id: 'doc-007-2', name: 'Birth Certificate', required: true, uploaded: true, fileName: 'rohan_birth_cert.pdf' },
      { id: 'doc-007-3', name: 'Ration Card Copy', required: true, uploaded: false },
      { id: 'doc-007-4', name: 'Income Certificate', required: true, uploaded: false },
      { id: 'doc-007-5', name: 'UDID Card', required: true, uploaded: true, fileName: 'rohan_udid_card.pdf' },
      { id: 'doc-007-6', name: 'Aadhaar Card', required: true, uploaded: true, fileName: 'rohan_aadhaar.pdf' },
      { id: 'doc-007-7', name: 'Bank Passbook', required: true, uploaded: false },
      { id: 'doc-007-8', name: 'Medication / Medical Documents', required: false, uploaded: false },
      { id: 'doc-007-9', name: 'Other Documents', required: false, uploaded: false },
      { id: 'doc-007-10', name: 'Notes', required: false, uploaded: false },
    ],
  },
  {
    id: 'stu-008',
    studentId: 'STU-2024-008',
    name: 'Ananya Deshmukh',
    dob: '2014-07-19',
    address: '31, Shanti Nagar, Near Railway Station',
    aadhaarNumber: '0123-4567-8901',
    udidNumber: 'UDID-MH-2024-011234',
    className: 'Primary - A',
    classTeacher: 'Dr. Sarah Mitchell',
    fatherName: 'Vijay Deshmukh',
    motherName: 'Lata Deshmukh',
    contactNumberF: '+91 21098 76543',
    contactNumberM: '+91 21098 76542',
    email: 'vijay.d@email.com',
    district: 'Nagpur',
    town: 'Sitabuldi',
    status: 'enrolled',
    enrolledDate: '2024-05-28',
    documents: [],
  },
  {
    id: 'stu-009',
    studentId: 'STU-2024-009',
    name: 'Mohammed Ayaan',
    dob: '2012-12-03',
    address: '67, Juhu Tara Road, Near Beach',
    aadhaarNumber: '1234-5678-9012',
    udidNumber: 'UDID-MH-2024-012345',
    className: 'Secondary - A',
    classTeacher: 'Ms. Emma Reyes',
    fatherName: 'Mohammed Irfan',
    motherName: 'Ayesha Irfan',
    contactNumberF: '+91 10987 65432',
    contactNumberM: '+91 10987 65431',
    email: 'irfan.m@email.com',
    district: 'Mumbai',
    town: 'Juhu',
    status: 'enrolled',
    enrolledDate: '2024-04-15',
    documents: [],
  },
  {
    id: 'stu-010',
    studentId: 'STU-2024-010',
    name: 'Kavya Iyer',
    dob: '2013-02-22',
    address: '88, Swami Vivekanand Marg, Old City',
    aadhaarNumber: '2345-6789-0123',
    udidNumber: 'UDID-MH-2024-013456',
    className: 'Primary - B',
    classTeacher: 'Mr. James Okafor',
    fatherName: 'Srinivasan Iyer',
    motherName: 'Lakshmi Iyer',
    contactNumberF: '+91 09876 54321',
    contactNumberM: '+91 09876 54320',
    email: 'srinivasan.i@email.com',
    district: 'Solapur',
    town: 'Solapur Central',
    status: 'draft',
    documents: [],
  },
  {
    id: 'stu-011',
    studentId: 'STU-2024-011',
    name: 'Arjun Reddy',
    dob: '2016-09-08',
    address: '12, Banjara Hills, Road No. 5',
    aadhaarNumber: '3456-7890-1235',
    udidNumber: 'UDID-MH-2024-014567',
    className: 'Pre Primary - A',
    classTeacher: 'Ms. Emily Watson',
    fatherName: 'Venkat Reddy',
    motherName: 'Padma Reddy',
    contactNumberF: '+91 98765 43212',
    contactNumberM: '+91 98765 43213',
    email: 'venkat.r@email.com',
    district: 'Nagpur',
    town: 'Wardha Road',
    status: 'enrolled',
    enrolledDate: '2024-08-01',
    documents: [],
  },
  {
    id: 'stu-012',
    studentId: 'STU-2024-012',
    name: 'Deepika Rao',
    dob: '2011-05-17',
    address: '45, Vidya Nagar, Near Bus Stand',
    aadhaarNumber: '4567-8901-2346',
    udidNumber: 'UDID-MH-2024-015678',
    className: 'Secondary - B',
    classTeacher: 'Mr. David Kumar',
    fatherName: 'Ramesh Rao',
    motherName: 'Kavita Rao',
    contactNumberF: '+91 87654 32110',
    contactNumberM: '+91 87654 32111',
    email: 'ramesh.rao@email.com',
    district: 'Amravati',
    town: 'Amravati Camp',
    status: 'enrolled',
    enrolledDate: '2024-06-30',
    documents: [],
  },
  {
    id: 'stu-013',
    studentId: 'STU-2024-013',
    name: 'Ishaan Gupta',
    dob: '2013-04-11',
    address: '22, Rani Bagh, Near Community Hall',
    aadhaarNumber: '5678-9012-3457',
    udidNumber: 'UDID-MH-2024-016789',
    className: 'Primary - B',
    classTeacher: 'Mr. James Okafor',
    fatherName: 'Manoj Gupta',
    motherName: 'Ritu Gupta',
    contactNumberF: '+91 76543 21099',
    contactNumberM: '+91 76543 21098',
    email: 'manoj.gupta@email.com',
    district: 'Nagpur',
    town: 'Sitabuldi',
    status: 'enrolled',
    enrolledDate: '2024-07-10',
    documents: [],
  },
  {
    id: 'stu-014',
    studentId: 'STU-2024-014',
    name: 'Fatima Begum',
    dob: '2014-01-28',
    address: '89, Madina Colony, Near Masjid',
    aadhaarNumber: '6789-0123-4568',
    udidNumber: 'UDID-MH-2024-017890',
    className: 'Primary - B',
    classTeacher: 'Mr. James Okafor',
    fatherName: 'Irfan Khan',
    motherName: 'Ruksana Khan',
    contactNumberF: '+91 65432 10988',
    contactNumberM: '+91 65432 10987',
    email: 'irfan.khan@email.com',
    district: 'Nagpur',
    town: 'Mominpura',
    status: 'enrolled',
    enrolledDate: '2024-06-10',
    documents: [],
  },
  {
    id: 'stu-015',
    studentId: 'STU-2024-015',
    name: 'Vishal Thakur',
    dob: '2013-08-15',
    address: '45, Shastri Nagar, Block C',
    aadhaarNumber: '7890-1234-5679',
    udidNumber: 'UDID-MH-2024-018901',
    className: 'Primary - B',
    classTeacher: 'Mr. James Okafor',
    fatherName: 'Ramesh Thakur',
    motherName: 'Geeta Thakur',
    contactNumberF: '+91 54321 09877',
    contactNumberM: '+91 54321 09876',
    email: 'ramesh.thakur@email.com',
    district: 'Nagpur',
    town: 'Itwari',
    status: 'enrolled',
    enrolledDate: '2024-08-01',
    documents: [],
  },
  {
    id: 'stu-016',
    studentId: 'STU-2024-016',
    name: 'Mei Ling Tan',
    dob: '2013-11-22',
    address: '33, Chinatown Lane, Opp. St. Mary\'s',
    aadhaarNumber: '8901-2345-6790',
    udidNumber: 'UDID-MH-2024-019012',
    className: 'Primary - B',
    classTeacher: 'Mr. James Okafor',
    fatherName: 'Wei Ming Tan',
    motherName: 'Siew Lan Tan',
    contactNumberF: '+91 43210 98766',
    contactNumberM: '+91 43210 98765',
    email: 'weiming.t@email.com',
    district: 'Nagpur',
    town: 'Dharampeth',
    status: 'enrolled',
    enrolledDate: '2024-07-22',
    documents: [],
  },
  {
    id: 'stu-017',
    studentId: 'STU-2024-017',
    name: 'Roshan Bhandari',
    dob: '2012-03-30',
    address: '17, Gopal Nagar, Ward No. 5',
    aadhaarNumber: '9012-3456-7891',
    udidNumber: 'UDID-MH-2024-020123',
    className: 'Primary - B',
    classTeacher: 'Mr. James Okafor',
    fatherName: 'Sunil Bhandari',
    motherName: 'Radha Bhandari',
    contactNumberF: '+91 32109 87655',
    contactNumberM: '+91 32109 87654',
    email: 'sunil.b@email.com',
    district: 'Nagpur',
    town: 'Wardha Road',
    status: 'pending',
    documents: [],
  },
  {
    id: 'stu-018',
    studentId: 'STU-2024-018',
    name: 'Nandini Pillai',
    dob: '2013-06-08',
    address: '66, Krishna Kunj, Lane 3, Civil Lines',
    aadhaarNumber: '0123-4567-8902',
    udidNumber: 'UDID-MH-2024-021234',
    className: 'Primary - B',
    classTeacher: 'Mr. James Okafor',
    fatherName: 'Gopal Pillai',
    motherName: 'Sarita Pillai',
    contactNumberF: '+91 21098 76544',
    contactNumberM: '+91 21098 76543',
    email: 'gopal.pillai@email.com',
    district: 'Nagpur',
    town: 'Civil Lines',
    status: 'enrolled',
    enrolledDate: '2024-05-18',
    documents: [],
  },
];